import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

/**
 * Login page. If already authenticated, redirect home. Otherwise
 * trigger Cognito Hosted UI on mount (and via a manual button as fallback
 * in case auto-redirect is blocked).
 */
export function AuthLogin(): JSX.Element {
  const { status, login } = useAuth();

  useEffect(() => {
    if (status === 'anonymous') {
      void login();
    }
  }, [status, login]);

  if (status === 'authenticated') return <Navigate to="/" replace />;

  return (
    <main className="flex min-h-screen items-center justify-center bg-gray-50 p-6">
      <div className="w-full max-w-sm rounded border border-gray-200 bg-white p-6 shadow-sm">
        <h1 className="text-xl font-semibold">サインイン</h1>
        <p className="mt-2 text-sm text-gray-600">Google 経由でログイン画面へ移動します…</p>
        <button
          type="button"
          onClick={() => void login()}
          className="mt-4 w-full rounded bg-gray-900 px-3 py-2 text-sm font-medium text-white hover:bg-gray-700"
        >
          Google でログイン
        </button>
      </div>
    </main>
  );
}
